<div class="part-exchange-vehicle">
	<!--  STATE A ~ VEHICLE REGISTRATION  -->

	<div *ngIf="pex_vehicle.state === 'a'" class="state-a">
		<div class="stripe bordered">
			<form
				class="form"
				name="configure_part_exchange_lookup_form"
				[formGroup]="pex_lookup_form"
				(submit)="onSubmitLookup()"
				(input)="onFormInput($event)"
				novalidate
			>
				<div class="row">
					<div class="col-xxs-30">
						<ui-text-control
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['registration']"
							[type]="'text'"
							[input_css_class]="pex_lookup_form.get('registration').value !== '' ? 'uppercase' : ''"
							[label]="'Vehicle Registration'"
							[placeholder]="'Enter vehicle registration...'"
						></ui-text-control>
					</div>
				</div>
				<div
					*ngIf="pex_lookup_method === 'manual'"
					class="row"
					data-element-view="manual_lookup_form__engage_configure_part_exchange[lookup]__[Manual Lookup Form]"
				>
					<div class="col-xxs-30">
						<ui-select-control
							*ngIf="dealer.use_vehicle_lookup_service"
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['type']"
							[label]="type_label"
							[placeholder]="'Select type...'"
							[options]="manual_lookup_types"
							[empty_allowed]="false"
							(changed)="onTypeChanged($event)"
						></ui-select-control>
					</div>
					<div class="col-xxs-30">
						<ui-select-control
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['manufacturer']"
							[label]="manufacturer_label"
							[placeholder]="'Select manufacturer...'"
							[options]="manual_lookup_manufacturers"
							[empty_allowed]="false"
							(changed)="onManufacturerChanged($event)"
						></ui-select-control>
					</div>
					<div class="col-xxs-30 col-sm-20">
						<ui-select-control
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['range']"
							[label]="'Range'"
							[placeholder]="'Select range...'"
							[options]="manual_lookup_ranges"
							[empty_allowed]="false"
							(changed)="onRangeChanged($event)"
							(click)="checkMakeModelControlState(['manufacturer'])"
						></ui-select-control>
					</div>
					<div class="col-xxs-30 col-sm-10 year-container">
						<ui-select-control
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['year']"
							[label]="'Year'"
							[placeholder]="'Select year...'"
							[options]="manual_lookup_years"
							[empty_allowed]="false"
							[disabled]="manual_lookup_years.length < 2"
							(changed)="onYearChanged($event)"
							(click)="checkMakeModelControlState(['manufacturer', 'range'])"
						></ui-select-control>
					</div>
					<div class="col-xxs-30">
						<ui-select-control
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['model']"
							[label]="'Model'"
							[placeholder]="'Select model...'"
							[options]="manual_lookup_filtered_models"
							[empty_allowed]="false"
							(changed)="onModelChanged($event)"
							(click)="checkMakeModelControlState(['manufacturer', 'range', 'year'])"
						></ui-select-control>
					</div>
					<div class="col-xxs-30">
						<ui-select-control
							[form]="pex_lookup_form"
							[form_control]="pex_lookup_form.controls['edition']"
							[label]="'Edition'"
							[placeholder]="'Select edition...'"
							[options]="manual_lookup_editions"
							[empty_allowed]="false"
							(click)="checkMakeModelControlState(['manufacturer', 'range', 'year', 'model'])"
						></ui-select-control>
					</div>
				</div>
				<div class="row lookup-actions">
					<div class="col-xxs-20 col-xs-22 col-sm-24">
						<a
							*ngIf="
								step_mode !== 'part_exchange' ||
								(step_mode === 'part_exchange' && pex_lookup_method === 'manual')
							"
							class="cancel-button"
							data-element-click="remove_button__engage_configure_part_exchange[lookup]__[Remove]"
							(click)="onRemove()"
						>
							<i class="icon-bin"></i>
							Remove
						</a>
					</div>
					<div class="col-xxs-10 col-xs-8 col-sm-6">
						<button
							class="button positive-button block-button"
							data-element-click="button__engage_configure_part_exchange[lookup]__positive-button[Submit]"
							[ngClass]="{ disabled: pex_lookup_form.invalid }"
							[class.loading]="pex_lookup_form_submitting"
						>
							<span class="loading-spinner"></span>
							<span *ngIf="!pex_lookup_form_submitting">Submit</span>
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>

	<!--  END STATE A ~ VEHICLE REGISTRATION  -->

	<!--  STATE B ~ EDIT VEHICLE DETAILS  -->

	<div *ngIf="pex_vehicle.state === 'b'" class="state-b">
		<div class="stripe bordered">
			<div class="inner">
				<cng-vehicle-title
					[vehicle]="pex_vehicle_info"
					[show_registration]="pex_vehicle.registration !== null"
				></cng-vehicle-title>
				<ui-icon-button
					[is_large]="true"
					[on_dark]="true"
					[use_branding]="true"
					[type]="'positive'"
					[icon]="'tick'"
					[tooltip]="'Save'"
					[placement]="'bottom'"
					data-element-click="tick_icon__engage_configure_part_exchange[details]__[Save]"
					(click)="onSubmitDetails()"
				></ui-icon-button>
				<ui-icon-button
					[is_large]="true"
					[on_dark]="true"
					[use_branding]="true"
					[type]="'negative'"
					[tooltip]="'Remove'"
					[placement]="'bottom'"
					[icon]="'bin'"
					data-element-click="bin_icon__engage_configure_part_exchange[details]__[Remove]"
					(click)="onRemove()"
				></ui-icon-button>
			</div>
		</div>
		<div class="details-container">
			<form
				name="configure_part_exchange_details_form"
				[formGroup]="pex_details_form"
				(submit)="onSubmitDetails()"
				(input)="onFormInput($event)"
				class="form"
			>
				<div class="row">
					<div *ngIf="editions.length !== 1" class="col-xxs-30">
						<!--<div class="col-xxs-30">-->
						<ui-select-control
							[form]="pex_details_form"
							[form_control]="pex_details_form.controls['edition']"
							[label]="'Edition'"
							[placeholder]="'Select edition...'"
							[options]="editions"
							[empty_allowed]="false"
							[info]="'Please select the closest match to your vehicle.'"
						></ui-select-control>
					</div>
					<div class="col-xxs-30 col-sm-14">
						<ui-text-control
							[form]="pex_details_form"
							[form_control]="pex_details_form.controls['mileage']"
							[label]="'Mileage'"
							[placeholder]="'Enter mileage...'"
							[type]="'number'"
							[info]="'The current mileage of the vehicle.'"
						></ui-text-control>
					</div>
					<div class="col-xxs-30 col-sm-14 col-sm-offset-2">
						<ui-select-control
							[form]="pex_details_form"
							[form_control]="pex_details_form.controls['condition']"
							[label]="'Condition'"
							[placeholder]="'Select condition...'"
							[options]="conditions"
							[empty_allowed]="false"
							[info]="'The current condition the vehicle is in.'"
						></ui-select-control>
					</div>
					<div *ngIf="asking_price" class="col-xxs-30 col-sm-14">
						<ui-text-control
							[form]="pex_details_form"
							[form_control]="pex_details_form.controls['asking_price']"
							[label]="'Asking Price'"
							[placeholder]="'Enter asking price...'"
							[type]="'currency'"
							[prefix]="'£'"
							[info]="'Please enter how much you would like for your vehicle.'"
						></ui-text-control>
					</div>
					<div class="col-xxs-30 col-sm-14" [ngClass]="{ 'col-sm-offset-2': asking_price }">
						<ui-text-control
							[form]="pex_details_form"
							[form_control]="pex_details_form.controls['finance_settlement']"
							[label]="'Finance Settlement (Optional)'"
							[placeholder]="'Enter finance settlement...'"
							[type]="'currency'"
							[prefix]="'£'"
							[info]="'The total amount of outstanding finance on this vehicle, if applicable.'"
						></ui-text-control>
					</div>
					<div class="col-xxs-30" [ngClass]="{ 'col-sm-14 col-sm-offset-2': !asking_price }">
						<ui-text-control
							[form]="pex_details_form"
							[form_control]="pex_details_form.controls['notes']"
							[type]="'textarea'"
							[label]="'Notes (Optional)'"
							[placeholder]="'Enter notes...'"
							[max_length]="1000"
							[info]="'e.g. MOT details, service history etc.'"
						></ui-text-control>
					</div>
					<button
						class="button positive-button"
						[attr.data-element-click]="
							'button__engage_configure_part_exchange[details]__[' + buttonLabel + ']'
						"
						[ngClass]="{ disabled: pex_details_form.invalid }"
						[class.loading]="pex_details_form_submitting"
					>
						<span class="loading-spinner"></span>
						<span *ngIf="!pex_details_form_submitting" class="text">
							<span>{{ buttonLabel }}</span>
						</span>
					</button>
				</div>
			</form>
		</div>
	</div>

	<!--  END STATE B ~ EDIT VEHICLE DETAILS  -->

	<!--  STATE C ~ DISPLAY VEHICLE VALUATION  -->

	<div *ngIf="pex_vehicle.state === 'c'" class="state-c">
		<div class="stripe bordered">
			<div class="inner">
				<cng-vehicle-title
					[vehicle]="pex_vehicle_info"
					[show_registration]="pex_vehicle.registration !== null"
				></cng-vehicle-title>
				<ui-icon-button
					[is_large]="true"
					[on_dark]="true"
					[icon]="'pencil'"
					[tooltip]="'Edit'"
					[placement]="'bottom'"
					data-element-click="pencil_icon__engage_configure_part_exchange[completed]__[Edit]"
					(click)="onEdit()"
				></ui-icon-button>
				<ui-icon-button
					[is_large]="true"
					[on_dark]="true"
					[use_branding]="true"
					[type]="'negative'"
					[tooltip]="'Remove'"
					[placement]="'bottom'"
					[icon]="'bin'"
					data-element-click="bin_icon__engage_configure_part_exchange[completed]__[Remove]"
					(click)="onRemove()"
				></ui-icon-button>
			</div>
		</div>
		<div class="details-container">
			<div class="row">
				<div class="col-xxs-30">
					<ul
						class="key-value-list striped valuation"
						[ngClass]="{ ranged: pex_vehicle.vehicle.min_value !== null }"
					>
						<li class="highlighted">
							<div class="key">
								{{ getValuationLabel() }}
							</div>
							<div class="value sec-fg sec-bg">
								<span *ngIf="pex_vehicle.vehicle.allowance !== null">
									<span *ngIf="pex_vehicle.vehicle.min_value !== null" class="min">
										{{ pex_vehicle.vehicle.min_value | money: 2 }}
									</span>
									<span *ngIf="pex_vehicle.vehicle.min_value !== null" class="to">-</span>
									<span class="max">
										{{
											(pex_vehicle.vehicle.min_value
												? pex_vehicle.vehicle.max_value
												: pex_vehicle.vehicle.allowance
											) | money: 2
										}}
										<span *ngIf="pex_vehicle.vehicle.min_value">*</span>
									</span>
								</span>
								<span *ngIf="pex_vehicle.vehicle.allowance === null">Awaiting valuation</span>
							</div>
						</li>
					</ul>

					<div *ngIf="pex_vehicle.vehicle.min_value">
						<p class="small-print align-center">
							* We will use the value of
							<strong>{{ pex_vehicle.vehicle.allowance | money: 2 }}</strong>
							in any further calculations.
						</p>
					</div>

					<p class="small-print">
						Any part exchange valuations obtained on this site are only estimates, based on the information
						you have submitted. The actual valuation will be agreed after we have appraised the part
						exchange vehicle. For full details please see our
						<a href="/configure/terms-of-use" target="_blank" class="text-hl">
							<strong>Terms of Use</strong>
						</a>
						.
					</p>

					<p class="small-print" *ngIf="configure_service.dealer.pex_disclaimer_text">
						{{ configure_service.dealer.pex_disclaimer_text }}
					</p>

					<ul class="key-value-list striped alt-style">
						<li>
							<div class="key">Edition:</div>
							<div class="value">{{ pex_vehicle.vehicle.edition }}</div>
						</li>
						<li>
							<div class="key">Mileage:</div>
							<div class="value">{{ pex_vehicle.vehicle.mileage | separated }}</div>
						</li>
						<li>
							<div class="key">Condition:</div>
							<div class="value">
								<a
									*ngIf="pex_vehicle.vehicle.condition === null"
									class="text-hl"
									data-element-click="edit_button__engage_configure_part_exchange[completed]__[Add condition]"
									(click)="onAddCondition()"
								>
									<strong>Add condition</strong>
								</a>
								<span *ngIf="pex_vehicle.vehicle.condition !== null">
									{{ getCondition(pex_vehicle.vehicle.condition) }}
								</span>
							</div>
						</li>
						<li *ngIf="asking_price">
							<div class="key">Asking Price:</div>
							<div class="value">
								<a
									*ngIf="
										pex_vehicle.vehicle.asking_price === null ||
										pex_vehicle.vehicle.asking_price === 0
									"
									class="text-hl"
									data-element-click="edit_button__engage_configure_part_exchange[completed]__[Add asking price]"
									(click)="onAddAskingPrice()"
								>
									<strong>Add asking price</strong>
								</a>
								<span
									*ngIf="
										pex_vehicle.vehicle.asking_price !== null &&
										pex_vehicle.vehicle.asking_price !== 0
									"
								>
									{{ pex_vehicle.vehicle.asking_price | money: 2 }}
								</span>
							</div>
						</li>
						<li>
							<div class="key">Finance Settlement:</div>
							<div class="value">
								<a
									*ngIf="
										pex_vehicle.vehicle.finance_settlement === null ||
										pex_vehicle.vehicle.finance_settlement === 0
									"
									class="text-hl"
									data-element-click="edit_button__engage_configure_part_exchange[completed]__[Add finance settlement]"
									(click)="onAddFinanceSettlement()"
								>
									<strong>Add finance settlement</strong>
								</a>
								<span
									*ngIf="
										pex_vehicle.vehicle.finance_settlement !== null &&
										pex_vehicle.vehicle.finance_settlement !== 0
									"
								>
									{{ pex_vehicle.vehicle.finance_settlement | money: 2 }}
								</span>
							</div>
						</li>
						<li>
							<div class="key">Notes:</div>
							<div class="value">
								<a
									*ngIf="pex_vehicle.vehicle.notes === null || pex_vehicle.vehicle.notes === ''"
									class="text-hl"
									data-element-click="edit_button__engage_configure_part_exchange[completed]__[Add notes]"
									(click)="onAddNotes()"
								>
									<strong>Add notes</strong>
								</a>
								<span *ngIf="pex_vehicle.vehicle.notes !== null && pex_vehicle.vehicle.notes !== ''">
									{{ pex_vehicle.vehicle.notes }}
								</span>
							</div>
						</li>
					</ul>
				</div>
				<div
					class="col-xxs-30 buttons-container"
					[class.has-many]="
						step_mode === 'part_exchange' && (reserve_available || (is_default_vehicle && website_url))
					"
				>
					<a
						class="button"
						data-element-click="button__engage_configure_part_exchange[completed]__primary-button[Edit]"
						(click)="onEdit()"
					>
						<span class="text">
							Edit
							<span *ngIf="!lte_xs">Details</span>
						</span>
					</a>
					<a
						*ngIf="step_mode === 'part_exchange' && reserve_available && !is_default_vehicle"
						class="button positive-button"
						data-element-click="button__engage_configure_part_exchange[completed]__[Reserve Now]"
						(click)="onReserve()"
					>
						<span class="text">
							Reserve
							<span *ngIf="!lte_xs">Now</span>
						</span>
					</a>
					<a
						*ngIf="step_mode === 'part_exchange' && is_default_vehicle && website_url"
						class="button positive-button"
						target="_blank"
						data-element-click="button__engage_configure_part_exchange[completed]__[Visit Showroom]"
						[href]="website_url"
					>
						<span class="text">Visit Showroom</span>
					</a>
				</div>
			</div>
		</div>
	</div>

	<!-- END STATE C ~ DISPLAY VEHICLE VALUATION  -->
</div>
